// Helpers puros da tela de orgânico (Instagram e Página): sem React e sem rede.

export const PLATFORM_LABELS = { instagram: 'Instagram', facebook: 'Facebook' }

// Taxa de engajamento do post: interações sobre o alcance. Sem alcance não há taxa.
export function engagementRate(post) {
  const reach = Number(post?.reach || 0)
  if (reach <= 0) return null
  return (Number(post.engagement || 0) / reach) * 100
}

export function formatRate(rate) {
  return rate === null || rate === undefined ? '—' : `${rate.toFixed(1).replace('.', ',')}%`
}

// Quem compõe o total de seguidores: com mais de uma conta, lista cada uma ("@a 326 · @b 197").
export function followersHint(accounts = []) {
  const list = (accounts || []).filter((a) => a && a.name)
  if (list.length < 2) return 'Total atual nas contas conectadas'
  return list.map((a) => `${a.name} ${Number(a.followers || 0).toLocaleString('pt-BR')}`).join(' · ')
}

// Resumo vindo do backend -> cartões de KPI.
export function summaryKpis(summary = {}) {
  const s = summary || {}
  // `interactions` vem do backend (o que aconteceu no período); a soma dos posts é o plano B.
  const interactions = s.interactions !== undefined && s.interactions !== null
    ? Number(s.interactions)
    : Number(s.likes || 0) + Number(s.comments || 0) + Number(s.shares || 0) + Number(s.saves || 0)
  return [
    { icon: 'users', label: 'Seguidores', value: Number(s.followers || 0), hint: followersHint(s.accounts) },
    { icon: 'eye', label: 'Alcance', value: Number(s.reach || 0), hint: 'Alcance somado dos posts do período' },
    { icon: 'target', label: 'Interações', value: interactions, hint: 'Curtidas, comentários, compartilhamentos e salvamentos no período' },
    { icon: 'chart', label: 'Posts', value: Number(s.posts || 0), hint: 'Publicações no período' },
  ]
}

// Série diária de seguidores (uma linha por plataforma/dia) -> uma linha por dia,
// com a soma das plataformas visíveis, ordenada por data.
export function followersByDay(rows = []) {
  const byDay = new Map()
  for (const row of rows || []) {
    const day = String(row.date).slice(0, 10)
    byDay.set(day, (byDay.get(day) || 0) + Number(row.followers || 0))
  }
  return [...byDay.entries()]
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([date, followers]) => ({ date, followers }))
}

// Variação de seguidores entre o primeiro e o último dia coletado.
export function followersGrowth(series = []) {
  if (series.length < 2) return null
  return series[series.length - 1].followers - series[0].followers
}

// Resultado do POST /organic/sync -> mensagem para a tela.
export function syncMessage(result) {
  const pages = result?.pages || []
  if (pages.length === 0) {
    return { tone: 'warn', text: 'Nenhuma Página conectada. Conecte uma Página em Configurações > Conexões.' }
  }
  const failed = pages.filter((p) => p.error)
  if (failed.length === pages.length) {
    return { tone: 'error', text: failed[0].error }
  }
  if (failed.length > 0) {
    return { tone: 'warn', text: `${failed.length} de ${pages.length} Páginas não puderam ser lidas. ${failed[0].error}` }
  }
  const noInstagram = pages.every((p) => !p.platforms?.instagram)
  // Estado do Instagram por Página (#320): ele usa a conexão própria do Instagram.
  const states = new Set(pages.map((p) => p.instagram))
  if (noInstagram && states.has('not_connected')) {
    return { tone: 'warn', text: 'Facebook atualizado. Conecte o Instagram em Configurações > Conexões para coletar o orgânico dele.' }
  }
  if (noInstagram && states.has('connection_error')) {
    return { tone: 'warn', text: 'Facebook atualizado. A conexão do Instagram não respondeu: reconecte o Instagram em Configurações > Conexões.' }
  }
  if (noInstagram && states.has('page_not_visible')) {
    return { tone: 'warn', text: 'Facebook atualizado. A conexão do Instagram não enxerga estas Páginas: reconecte o Instagram com a mesma conta do Facebook.' }
  }
  return {
    tone: 'ok',
    text: noInstagram
      ? 'Coletado. Nenhuma conta do Instagram Business está vinculada às Páginas.'
      : 'Dados atualizados.',
  }
}
